/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class QueryStatsTemplateSelectionService {
  private pendingTemplate: any;

  select(template: any): void {
    this.pendingTemplate = template;
  }

  consume(type: string): any | null {
    if (!this.pendingTemplate || this.pendingTemplate.type !== type) {
      return null;
    }
    const selected = this.pendingTemplate;
    this.pendingTemplate = null;
    return selected;
  }
}
